import { WarningTwoTone } from "@ant-design/icons";
import { Modal } from "antd";

interface ConfirmModalProps {
    text: string;
    isModalOpen: boolean;
    isLoading: boolean;
    onCancel: () => void;
    onOk: () => void;
}

const ConfirmWarningModal: React.FC<React.PropsWithChildren<ConfirmModalProps>> = ({ text, isModalOpen, isLoading, onOk, onCancel }) => {
    return (
        <Modal title={<span><WarningTwoTone style={{ marginRight: '0.2rem' }} twoToneColor='#ffc212' /> Attention</span>}
            centered
            open={isModalOpen}
            onOk={onOk}
            okText='Supprimer'
            closeIcon={false}
            confirmLoading={isLoading}
            okButtonProps={{ danger: true, ghost: true }}
            onCancel={onCancel}>
            <p>{text}</p>
        </Modal>
    );
};

export default ConfirmWarningModal;